import {BuildType, MortgageTypes} from "../../../../../models";
import useMortgage from "../../../../providers/mortgage/useMortgage";
import {
    adminGiftCertificateSection
} from "../../../../providers/mortgage/uploads/verified-upload-sections/gift-certificate/section";

export function customerPreApprovalDocumentsToCreate(mortgage) {
    const submissions = mortgage.submissions.sort((a, b) => {
        return new Date(b.createdAt) - new Date(a.createdAt)
    })
    const activeSubmission = submissions.length ? submissions[0] : null

    const items = []
    if (!activeSubmission) {
        return items
    }



    // 1. Lender Checklist
    switch (activeSubmission?.lenderCode) {
        case 'avant':

            if (mortgage.requirement.receivingGifts && mortgage.requirement.depositGifts > 0) {
                items.push({
                    name  : 'avant-gift-letter',
                    folder: 'downloads',
                    overlay: true,
                    dataType: adminGiftCertificateSection
                })
            }
            break;
        case 'ptsb':

            if (mortgage.requirement.receivingGifts && mortgage.requirement.depositGifts > 0) {
                items.push({
                    name  : 'ptsb-gift-letter',
                    folder: 'downloads',
                    overlay: true,
                    dataType: adminGiftCertificateSection
                })
            }
            if (mortgage.properties[0]?.buildType === BuildType.SELFBUILD) {
                items.push({
                    name  : 'self-build-projected-costing',
                    folder: 'downloads'
                }, {
                    name  : 'certificate-of-inspection-statutory',
                    folder: 'downloads'
                }, {
                    name  : 'certificate-of-inspection-opt-out',
                    folder: 'downloads'
                })
            }
            break;
        case 'haven':
            items.push({
                name   : 'interest-rate-application-form',
                overlay: true,
                folder : 'customer-docusign'
            })
            if (mortgage.requirement.receivingGifts && mortgage.requirement.depositGifts > 0) {
                items.push({
                    name  : 'haven-gift-letter',
                    folder: 'downloads',
                    overlay: true,
                    dataType: adminGiftCertificateSection
                })
            }
            let rateModel = mortgage.activeSubmission?.finalRateModel || mortgage.activeSubmission?.provisionalRateModel
            let loan = mortgage.activeSubmission?.finalLoan || mortgage.activeSubmission?.provisionalLoan || mortgage.requirement.loanRequired
            let fiveGrandAvailable = rateModel && loan >= 250000 && !!rateModel.term && !rateModel?.conditions?.includes('BER B3 or better required') && !rateModel?.conditions?.includes('Green')
            let cashbackDocRequired = mortgage.mortgageType === MortgageTypes.REFINANCE || fiveGrandAvailable

            if (cashbackDocRequired) {
           // if (!(mortgage.requirement.lenderProduct || '').toLowerCase().includes('green')) {
                items.push({
                    name   : 'cashback-brochure',
                    overlay: false,
                    folder : 'lender-documents',
                })
                items.push({
                    name   : 'cashback-form',
                    overlay: true,
                    folder : 'customer-docusign',
                })
            }

            break;
        case 'boi':
            if (mortgage.requirement.receivingGifts && mortgage.requirement.depositGifts > 0) {
                items.push({
                    name: 'boi-gift-template',
                    fill: true,
                    folder: 'downloads'
                })
            }
            break;
    }
    return items.map(item => {
        return {
            ...item,
            key      : item.name +'/'+ item.folder+'/'+activeSubmission?.id,
            private  : false,
            generated: mortgage.UserMortgageDocuments.find(doc => doc.folder === item.folder && doc.name === item.name && doc.submissionID === activeSubmission?.id),
        }
    })
}

function useCustomerPreApprovalDocuments(props) {
    // 1. Items to copy into customer lender documents folder
    // 2. Items to create for use as download template for customer uploads
    // 3. Items to create to be docusigned by customer

    const mortgage = useMortgage()
    return customerPreApprovalDocumentsToCreate(mortgage)
}

export default useCustomerPreApprovalDocuments;